import { runValidation } from '@/core/validation/ValidationProcessor'
import { UnsavedDataManager } from '@/core/item_assistance/unsavedDataManager'
import { updateModificationInfo } from '@/core/item_assistance/itemAdditionals'
import { getCurrentUrlParameters, getLocalizedMessage, loadConfig, saveConfig, showMessageAlert } from '@/core/shared'
import { dataCapture } from '@/core/item_assistance/itemDataCapture'
import { generateDifferentialJson } from '@/core/item_assistance/generatingDifferentialJson'
import { mergeData, mergeDataSLSN } from '@/core/item_assistance/mergeItemData'
import { flatDeepAttributes } from 'utils/format'


export function ItemProcessor () {
	'use strict'
	this.itemId = undefined
	this.itemData = {}
	this.attributesGroups = {}
	this.allAttributesForGroups = []
	this.itemPk = {}
	this.localization = {}
	this.language = {}
	this.itemValidationRules = {}
	this.prevValuesDictionary = {}
	this.classificators = {}
	this.measurementUnits = {}
	this.sourceItemData = undefined
	this.itemConfig = undefined
	this.selectedAttribute = undefined
	this.saveSuccessString = 'changes.saved'
	this.saveErrorString = 'error.saving'
	this.saveValidationError = 'there.are.incorrect.data'
	this.createNewItemButtonMessage = 'create.new.item'
	this.goToItemTableButtonMessage = 'go.to.items.table'
	this.dataJson = {}
	this.differentialJson = {}
	this.waitingForServerAnswer = false
	this.unsavedDataManager = new UnsavedDataManager(this)
	this.enableCopyAttributeName = false
	this.enableBreadcrumbItemDescription = true
	this.isSaved = false
	this.decimalOrDigitSettings = {}

	this.setItemId = function (itemId) {
		this.itemId = itemId
	}

	this.setItemData = function (data) {
		this.itemData = data
		updateModificationInfo(data)
		if (this.itemId && this.enableBreadcrumbItemDescription) {
			this.initBreadcrumbItemDescription()
			this.enableBreadcrumbItemDescription = false
		}
	}

	this.setSourceItemData = function (data) {
		this.sourceItemData = data
	}

	this.setItemPk = function (itemPk) {
		this.itemPk = itemPk
	}

	this.setLocalization = function (localization) {
		this.localization = localization
	}

	this.setLanguage = function (language) {
		this.language = language
	}

	this.setItemValidationRules = function (itemValidationRules) {
		this.itemValidationRules = itemValidationRules
	}

	this.setDecimalOrDigitSettings = function (decimalOrDigitSettings) {
		this.decimalOrDigitSettings = decimalOrDigitSettings
	}

	this.setAttributesGroups = function (attributesGroups) {
		this.attributesGroups = attributesGroups
		this.allAttributesForGroups = this.getAllAttributesForGroups(attributesGroups)
	}

	this.setPrevValuesDictionary = function (prevValuesDictionary) {
		this.prevValuesDictionary = prevValuesDictionary
	}

	this.setClassificators = function (classificators) {
		this.classificators = classificators
	}

	this.setMeasurementUnits = function (measurementUnits) {
		this.measurementUnits = measurementUnits
	}

	this.getDecimalOrDigitSettings = function () {
		return this.decimalOrDigitSettings
	}

	this.getAllAttributesForGroups = function (attributes) {
		return flatDeepAttributes(attributes);
	}

	this.initBreadcrumbItemDescription = function () {
		let breadcrumb = $('.uk-breadcrumb'),
			langSystem = window.locale.toUpperCase(),
			itemBreadcrumb = null

		if (this.itemData['trade_item_description'] && !this.itemConfig['trade_item_description'].format) {
			itemBreadcrumb = this.itemData['trade_item_description'][langSystem]
		}

		if (this.itemData['invoice_name'] && !this.itemConfig['invoice_name'].format) {
			itemBreadcrumb = this.itemData['invoice_name'][langSystem]
		}

		if (this.itemData['name_invoice'] && !this.itemConfig['name_invoice'].format) {
			itemBreadcrumb = this.itemData['name_invoice'][langSystem]
		}

		if (itemBreadcrumb) {
			breadcrumb.append(
				'<li><span>' + itemBreadcrumb + '</span></li>'
			)
		}

		breadcrumb.append(
			'<li><span>' + this.itemId + '</span></li>'
		)
	}

	this.setEnableCopyAttributeName = function () {
		var event = new Event('enableCopyAttributeName')
		document.dispatchEvent(event)
		$('div.sl-editor span.label-copy-icon').each(function (index, value) {
			if ($(value).hasClass('dn')) {
				$(value).removeClass('dn')
			} else {
				$(value).addClass('dn')
			}
		})
		this.enableCopyAttributeName = !this.enableCopyAttributeName
	}

	this.getEnableCopyAttributeName = function () {
		return this.enableCopyAttributeName
	}

	this.loadItemData = function () {
		$.ajax({
			url: window.urlContext + 'items/' + this.itemId + '/load',
			type: 'GET',
			dataType: 'json',
			async: false,
			context: this,
			success: function (data) {
				this.setItemData(data)
			}
		})
	}

	this.loadSourceItemData = function (sourceItemId, vm) {
		if (sourceItemId) {
			$.ajax({
				url: window.urlContext + 'items/' + sourceItemId + '/load',
				type: 'GET',
				dataType: 'json',
				async: false,
				context: this,
				success: function (sourceData) {
					this.sourceItemData = sourceData;
					const itemStructure = vm.$store.getters.getItemStructure
					const langs = vm.$store.getters.getLanguage
					let dataItemTo = vm.itemData
					let dataItemFrom = sourceData
					let resData = mergeData(dataItemTo, dataItemFrom)

					let unsavedData = {}
					mergeDataSLSN(dataItemTo, dataItemFrom, itemStructure, langs, unsavedData, resData)

					vm.$set(vm, 'itemData', resData);
					vm.$store.commit('UPDATE_ITEM_DATA', resData)

					this.unsavedDataManager.setUnsavedData(unsavedData)
				}
			})
		}
	}

	this.setItemConfig = function (itemConfig) {
		this.itemConfig = itemConfig
	}

	this.initItemAttributeControls = function (preferDefault, activeAttribute, itemData) {
		var simpleItemUpdate = !_.has(getCurrentUrlParameters(), 'sourceItemId')
		var url = document.location.href.split('?')[0]
		var itemState = {}
		if (simpleItemUpdate) {
			(this.itemId !== false) ? itemState = loadConfig('itemEdit.' + this.itemId) : itemState = loadConfig('newItem_state')
			if (!_.isEmpty(itemState)) {
				window.ClientSessionManager.restoreItemState(itemState, this.itemData, activeAttribute)
			} else {
				// initData(this.itemData, this.sourceItemData, this.itemConfig, preferDefault)
			}
			history.pushState(null, null, url)
		} else {
			// initData(this.itemData, this.sourceItemData, this.itemConfig, preferDefault)
			history.replaceState(null, null, url)
		}
		var data = {}
		dataCapture(this.itemConfig, data, { includeEmptyNM: true })
		if (!_.isEmpty(itemState)) {
			// data = mergeDataForStateRestoring(itemState.data, data, this.itemConfig);
		}
		// this.unsavedDataManager.setUnsavedData(generateDifferentialJson(data, this.itemConfig, this.itemData))
		// this.unsavedDataManager.updateUnsavedDataSign()
	}

	function prepareStatusForAlert (status) {
		var html = '<div class="item-status-inf">'
		_.each(status, function (value, key) {
			html += (value ? '<span class="completed-status">' : '<span class="uncompleted-status">') + key + '</span>'
		})
		return html + '</div>'
	}

	this.submitEditedItem = function (callback) {
		this.waitingForServerAnswer = true
		$.ajax({
			url: window.urlContext + 'items/' + this.itemId + '/save',
			type: 'POST',
			dataType: 'json',
			context: this,
			data: JSON.stringify(this.differentialJson),
			contentType: 'application/json',
			mimeType: 'application/json',
			success: function (itemResult) {
				if (!_.isEmpty(itemResult.itemId)) {
					var statusHtml = prepareStatusForAlert(itemResult.status)
					saveConfig('itemEdit.' + this.itemId, JSON.stringify({}))
					sessionStorage.setItem('justStateSaved', true)
					$('.sweet-alert.visible').focus()
					this.loadItemData(this.itemId)
					this.unsavedDataManager.clearData()
					this.unsavedDataManager.updateUnsavedDataSign()
					this.isSaved = true
					callback(this.itemData)
					showMessageAlert(getLocalizedMessage(this.saveSuccessString), 'success', statusHtml)
				} else {
					// showErrorMessage(getLocalizedMessage(this.saveErrorString), itemResult.message);
					showMessageAlert(getLocalizedMessage(this.saveErrorString), 'danger', itemResult.message)
				}
				this.dataJson = {}
				this.waitingForServerAnswer = false
			},
			error: function () {
				this.waitingForServerAnswer = false
			}
		})
	}

	this.submitNewItem = function () {
		this.waitingForServerAnswer = true
		var itemProcessor = this
		$.ajax({
			url: window.urlContext + 'items/save',
			type: 'POST',
			dataType: 'json',
			context: this,
			data: JSON.stringify(this.differentialJson),
			contentType: 'application/json',
			mimeType: 'application/json',
			success: function (itemResult) {
				if (!_.isEmpty(itemResult.itemId)) {
					var statusHtml = prepareStatusForAlert(itemResult.status)
					saveConfig('newItem_state', JSON.stringify({}))
					sessionStorage.setItem('justStateSaved', true)
					showMessageAlert(getLocalizedMessage(this.saveSuccessString), 'success', statusHtml)
					itemProcessor.unsavedDataManager.updateUnsavedDataSign()
				} else {
					showMessageAlert(getLocalizedMessage(this.saveErrorString), 'danger', itemResult.message)
				}
				this.dataJson = {}
				this.waitingForServerAnswer = false
			},
			error: function () {
				this.waitingForServerAnswer = false
			}
		})
	}

	this.captureAndSubmitItemData = function (submitFunctionName, callback) {
		if (this.waitingForServerAnswer) {
			window.alert('Request is already submitted. Waiting for server response.')
			return
		}

		dataCapture(this.itemConfig, this.dataJson)
		if (!_.isEmpty(this.dataJson)) {
			if (runValidation(this.dataJson, this.itemConfig)) {
				this.differentialJson = generateDifferentialJson(this.dataJson, this.itemConfig, this.itemData, this.allAttributesForGroups)
				if (!_.isEmpty(this.differentialJson)) {
					this[submitFunctionName](callback)
				} else {
					this.unsavedDataManager.updateUnsavedDataSign()
				}
			} else {
				showMessageAlert(getLocalizedMessage(this.saveValidationError), 'danger')
			}
		}
	}

	this.itemUpdate = function (callback) {
		this.captureAndSubmitItemData('submitEditedItem', callback)
	}

	this.itemCreate = function () {
		this.captureAndSubmitItemData('submitNewItem', null)
	}
}
